import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem, Icon, Typography } from '@web-chat-core/ui-kit';
import { useModal } from 'useCase/modal/useModal';
import { ModalName } from 'features/Modals';

export const SoundAndCameraSettingsMenuItem = () => {
    const { t } = useTranslation();

    const { toggleModal } = useModal();

    const onClick = useCallback(() => {
        toggleModal(ModalName.SOUND_SETTINGS);
    }, [toggleModal]);

    return (
        <MenuItem id="sound-and-camera-settings-menu-item" type="dropdown" onClick={onClick}>
            <Icon icon="icSettings24" colorVariant="basic" />
            <Typography variant="body3" colorVariant="base">
                {t('vks_microphone_audio_camera_settings')}
            </Typography>
        </MenuItem>
    );
};

SoundAndCameraSettingsMenuItem.displayName = 'SoundAndCameraSettingsMenuItem';
